import { useSuspenseQuery } from "@tanstack/react-query"

import { useClient } from "api"

import { BrandingApiResponse, mapBrandingResponse, PracticeSettings } from "../types"

const useSettings = (orgId: string) => {
  const { read } = useClient()

  const queryKey = ["settings", orgId]

  const { data, isLoading } = useSuspenseQuery({
    queryKey,
    queryFn: async () => {
      const settings = await read<BrandingApiResponse>(`aidbox/resolve-setting/${orgId}`)

      return mapBrandingResponse(settings)
    },
  })

  return { settings: data as PracticeSettings, isLoading }
}

export { useSettings }
